export default __webpack_public_path__ + "static/media/huit.4cdbccb7.jpg";